export default "__VITE_ASSET__b0044415__"